import deleteone from "../../assests/deleteone.gif";
import CustomTooltip from "../Buttons/CustomTooltip"; // ✅ import tooltip

function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  message,
  confirmText = "Delete",
  confirmClass = "btn-danger",
  actionType = "delete", // "delete" | "restore" | "delete permanently"
}) {
  if (!isOpen) return null;

  const actionIcon =
    actionType === "delete" ? deleteone : "/assets/images/restore .gif";

  return (
    <div className="overlay_delete">
      <div className="modal_delete">
        <div className="header_delete">
          <h3 className="title_delete">
            {actionType === "delete"
              ? "Delete"
              : actionType === "delete permanently"
              ? "Delete Permanently"
              : "Restore"}
          </h3>

          <CustomTooltip
            content="Close"
            placement="left"
            fallbackPlacements={["bottom"]}
          >
            <i
              onClick={onClose}
              className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor me-2"
            />
          </CustomTooltip>
        </div>

        <div className="body_delete">
          <img
            src={actionIcon}
            alt={`${actionType}-icon`}
            className="icon_delete"
          />
          <p className="text_delete">{message}</p>
        </div>

        <div className="footer_delete">
          <button
            className="btn btn-closebtn custom-button"
            onClick={onClose}
            disabled={isLoading}
          >
            Close
          </button>
          <button
            className={`btn ${confirmClass} custom-button`}
            disabled={isLoading}
            onClick={onConfirm}
          >
            {isLoading
              ? actionType === "delete"
                ? "Deleting..."
                : actionType === "delete permanently"
                ? "Deleting Permanently..."
                : "Restoring..."
              : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;
